import React, { useState, useEffect } from "react";
import {
  Typography,
  Box,
  IconButton,
  Avatar,
  AppBar,
  Toolbar,
  Tabs,
  Tab,
  Grid,
  Tooltip,
  TextField,
  CircularProgress,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  InputAdornment,
  Breadcrumbs,
  Link,
  Checkbox,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
} from "@mui/material";
import {
  Notifications,
  CalendarToday,
  Search,
  Home,
  ArrowBackIos,
} from "@mui/icons-material";
import { InfoOutlined } from "@mui/icons-material";
import VisibilityIcon from "@mui/icons-material/Visibility";
import { useNavigate } from "react-router-dom";
import { VendorappBar } from "../../../components";
import { useSelector } from "react-redux";
import { useFetch } from "../../../hooks";
import { BASE_URL_TEST } from "../../../utils/baseUrl";
import { urls } from "../../../urls/urls";

const statusColors = {
  "Agent Assigned": "#E8F5E9",
  "ACCEPTED": "#E8F5E9",
  Picked: "#E3F2FD",
  Shipped: "#F3E5F5",
  Delivered: "#E8F5E9",
  Cancelled: "#FFEBEE",
  "REJECTED": "#FFE5E5",
};

const statusTextColors = {
  "Agent Assigned": "#2E7D32",
  "ACCEPTED": "#2E7D32",
  Picked: "#1976D2",
  Shipped: "#7B1FA2",
  Delivered: "#388E3C",
  Cancelled: "#C62828",
  "REJECTED": "#D32F2F",
};

const initialOrderData = [
  {
    id: "#6548",
    created: "2 min ago",
    customer: "Joseph Wheeler",
    total: "₹654",
    profit: "₹154",
    profitPercent: "16%",
    status: "Agent Assigned",
    trackingNumber: "TN001",
    agentName: "Raj Kumar",
    agentPhone: "+91 9876543210",
    city: "Mumbai",
    varientName: "Red T-Shirt",
  },
  {
    id: "#6549",
    created: "10 min ago",
    customer: "Michael Smith",
    total: "₹854",
    profit: "₹254",
    profitPercent: "20%",
    status: "Agent Assigned",
    trackingNumber: "TN002",
    agentName: "Priya Sharma",
    agentPhone: "+91 9876543211",
    city: "Delhi",
    varientName: "Blue Jeans",
  },
  {
    id: "#6550",
    created: "15 min ago",
    customer: "Anna Johnson",
    total: "₹354",
    profit: "₹54",
    profitPercent: "8%",
    status: "Picked",
    trackingNumber: "TN003",
    agentName: "Amit Patel",
    agentPhone: "+91 9876543212",
    city: "Bangalore",
    varientName: "White Shoes",
  },
  {
    id: "#6551",
    created: "20 min ago",
    customer: "Chris Lee",
    total: "₹554",
    profit: "₹154",
    profitPercent: "15%",
    status: "Picked",
    trackingNumber: "TN004",
    agentName: "Sunita Singh",
    agentPhone: "+91 9876543213",
    city: "Chennai",
    varientName: "Black Jacket",
  },
  {
    id: "#6552",
    created: "25 min ago",
    customer: "Jessica Brown",
    total: "₹754",
    profit: "₹254",
    profitPercent: "25%",
    status: "Shipped",
    trackingNumber: "TN005",
    agentName: "Ravi Gupta",
    agentPhone: "+91 9876543214",
    city: "Pune",
    varientName: "Green Dress",
  },
];

const progressData = [
  {
    status: "Order Placed",
    location: "New York, USA",
    date: "August 29, 2020",
    time: "2:00 pm",
  },
  {
    status: "Documentation Prepared",
    location: "New York, USA",
    date: "August 29, 2020",
    time: "3:30 pm",
  },
  {
    status: "Booking Arranged",
    location: "New York, USA",
    date: "August 29, 2020",
    time: "3:35 pm",
  },
  {
    status: "Collected",
    location: "New York, USA",
    date: "August 29, 2020",
    time: "4:00 pm",
  },
  {
    status: "In Transit to Destination",
    location: "New York, USA",
    date: "August 29, 2020",
    time: "6:00 pm",
  },
  {
    status: "Arrived at Destination",
    location: "London, United Kingdom",
    date: "",
    time: "",
  },
  {
    status: "Out for Delivery",
    location: "London, United Kingdom",
    date: "",
    time: "",
  },
  {
    status: "Delivered",
    location: "London, United Kingdom",
    date: "",
    time: "",
  },
];

export default function IntegrationwithDeliverySystem({ onBackScreenName }) {
  const [mainTab, setMainTab] = useState(0);
  const [selectedTab, setSelectedTab] = useState(0);
  const [searchValue, setSearchValue] = useState("");
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [open, setOpen] = useState(false);
  const [selectedOrder, setSelectedOrder] = useState(null);
  const [status, setStatus] = useState("");
  const [trackingNumber, setTrackingNumber] = useState("");
  const [orderData, setOrderData] = useState([]);
  const [isOrderModalOpen, setOrderModalOpen] = useState(false);
  const navigate = useNavigate();
  const userDetails = useSelector((state) => state.user.userdetails);
  const userVtype = userDetails?.vtype;
  const loginToken = useSelector((state) => state.user.logintoken);
  console.log("userVtype", userVtype);

  // Initialize useFetch hook for fetchOrderStatus API
  const {
    data: orderStatusData,
    error: orderStatusError,
    isLoading: orderStatusLoading,
    fetchData: fetchOrderStatusData,
  } = useFetch(BASE_URL_TEST + urls("fetchOrderStatus"), {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Authorization: loginToken ? `Bearer ${loginToken}` : "",
    },
  });

  // Fetch orders based on selected tab
  useEffect(() => {
    setLoading(true);

    // Map tab index to status
    const statusMap = {
      0: "ACCEPTED",      // Agent Assigned tab
      1: "Picked",        // Picked tab
      2: "Shipped",       // Shipped tab
      3: "Delivered",     // Delivered tab
      4: "REJECTED"       // Cancelled tab (REJECTED status)
    };

    const orderStatus = statusMap[selectedTab];
    if (orderStatus) {
      fetchOrderStatusData({
        type: "admin",
        vendor_id: userDetails?.id || "0",
        order_status: orderStatus
      });
    }
  }, [selectedTab]);

  // Handle API response
  useEffect(() => {
    if (orderStatusError) {
      console.error("Error fetching order status data:", orderStatusError);
      setLoading(false);
    } else if (orderStatusData) {
      console.log("Order status data received:", orderStatusData);

      // Check if data exists
      if (orderStatusData.data && Array.isArray(orderStatusData.data)) {
        // Helper function to format date
        const formatDate = (dateString) => {
          if (!dateString) return "N/A";
          const date = new Date(dateString);
          const now = new Date();
          const diffMs = now - date;
          const diffMins = Math.floor(diffMs / 60000);
          const diffHours = Math.floor(diffMs / 3600000);
          const diffDays = Math.floor(diffMs / 86400000);

          if (diffMins < 1) return "Just now";
          if (diffMins < 60) return `${diffMins} min ago`;
          if (diffHours < 24) return `${diffHours} hour${diffHours > 1 ? 's' : ''} ago`;
          if (diffDays < 7) return `${diffDays} day${diffDays > 1 ? 's' : ''} ago`;

          return date.toLocaleDateString('en-IN', {
            year: 'numeric',
            month: 'short',
            day: 'numeric',
            hour: '2-digit',
            minute: '2-digit'
          });
        };

        // Transform API data to match component structure
        const transformedData = orderStatusData.data.map((order) => ({
          // Original API fields
          ...order,

          // Mapped fields for backward compatibility
          id: order.cartDetails?.cart_number,
          cart_number: order.cartDetails?.cart_number,
          created: formatDate(order.createdAt),
          customer: order.cartDetails?.customerDetails
            ? `${order.cartDetails.customerDetails.first_name || ""} ${order.cartDetails.customerDetails.last_name || ""}`.trim()
            : "N/A",
          total: order.cartDetails?.cart_total_amount
            ? `₹${order.cartDetails.cart_total_amount}`
            : "N/A",
          total_amount: order.cartDetails?.cart_total_amount
            ? `₹${order.cartDetails.cart_total_amount}`
            : "N/A",
          profit: order.cartDetails?.cart_total_amount
            ? `₹${(order.cartDetails.cart_total_amount * 0.15).toFixed(2)}`
            : "N/A",
          profitPercent: "15%",
          status: order.order_status,
          trackingNumber: order.cartDetails?.transaction_id,
          agentName: order.agentDetails?.first_name && order.agentDetails?.last_name
            ? `${order.agentDetails.first_name} ${order.agentDetails.last_name}`.trim()
            : "N/A",
          agentPhone: order.agentDetails?.phone_number || "N/A",
          city: order.cartDetails?.customerDetails?.city ||
                order.cartDetails?.vendors?.[0]?.vendorDetails?.city ||
                "N/A",
          varientName: order.cartDetails?.vendors?.[0]?.items?.[0]?.product?.name || "N/A",
          // Keep nested structure for detailed view
          cart: order.cartDetails,
        }));

        setOrderData(transformedData);
        setLoading(false);
      } else {
        console.log("No order status data found");
        setOrderData([]);
        setLoading(false);
      }
    }
  }, [orderStatusData, orderStatusError]);

  const handleEditClick = (order) => {
    setSelectedOrder(order);
    setTrackingNumber(order.trackingNumber);
    setStatus(order.status);
    setOrderModalOpen(true);
  };

  const handleModalClose = () => {
    setOrderModalOpen(false);
    setSelectedOrder(null);
  };

  const handleBackClick = () => {
    if (onBackScreenName) {
      onBackScreenName("Dashboard");
    } else {
      navigate(-1);
    }
  };

  const handleTabChange = (event, newValue) => {
    setSelectedTab(newValue);
  };

  const handleSearchChange = (event) => {
    setSearchValue(event.target.value);
  };

  const filteredOrders = orderData.filter((order) =>
    order?.id?.toString().toLowerCase().includes(searchValue.toLowerCase()) ||
    order?.cart_number?.toString().toLowerCase().includes(searchValue.toLowerCase())
  );
  const handleScreeName = (sname) => {
    onBackScreenName(sname);
  };

  return (
    <Box sx={{ display: "flex" }}>
      <Box
        component="main"
        sx={{
          flexGrow: 1,
          bgcolor: "#EEF2FF",
          p: 3,
          overflowY: "auto",
          display: "flex",
          flexDirection: "column",
        }}
      >
        {/* AppBar */}
        {/* <AppBar
          position="static"
          elevation={0}
          sx={{
            borderBottom: "1px solid #ddd",
            mb: 2,
            backgroundColor: "white",
            color: "black",
            borderRadius: "20px",
          }}
        >
          <Toolbar>
            <Typography variant="h6" noWrap sx={{ flexGrow: 1 }}>
              Delivery Orders Management
            </Typography>

            <IconButton>
              <CalendarToday />
            </IconButton>
            <Typography variant="body1" sx={{ mx: 2 }}>
              28 Dec, 2024
            </Typography>
            <IconButton>
              <Notifications />
            </IconButton>
            <Avatar alt="Gn" src="/profile.webp" />
          </Toolbar>
        </AppBar> */}

        {/* Back Button */}
        {/* <Box sx={{ mb: 2 }}>
          <Button
            startIcon={<ArrowBackIos />}
            onClick={handleBackClick}
            sx={{
              color: "#3f51b5",
              fontWeight: "bold",
              textTransform: "none",
              "&:hover": {
                backgroundColor: "rgba(63, 81, 181, 0.1)",
              },
            }}
          >
            Back
          </Button>
        </Box> */}

        <VendorappBar
          title={
            userVtype === "vlistuser"
              ? "Delivery Management"
              : "Delivery Orders Management"
          }
          onBackScreenName={handleScreeName}
        />

        <Box
          component="main"
          sx={{ flexGrow: 1, bgcolor: "#EEF2FF", overflowY: "auto" }}
        >
          <Tabs value={selectedTab} onChange={handleTabChange} sx={{ mb: 2 }}>
            <Tab
              label="Agent Assigned"
              sx={{ color: selectedTab === 0 ? "#4F46E5" : "inherit" }}
            />
            <Tab
              label="Picked"
              sx={{ color: selectedTab === 1 ? "#4F46E5" : "inherit" }}
            />
            <Tab
              label="Shipped"
              sx={{ color: selectedTab === 2 ? "#4F46E5" : "inherit" }}
            />
            <Tab
              label="Delivered"
              sx={{ color: selectedTab === 3 ? "#4F46E5" : "inherit" }}
            />
            <Tab
              label="Cancelled"
              sx={{ color: selectedTab === 4 ? "#4F46E5" : "inherit" }}
            />
          </Tabs>

          <Box sx={{ display: "flex", alignItems: "center", mb: 3 }}>
            <TextField
              placeholder="Search by order id"
              variant="outlined"
              size="small"
              value={searchValue}
              onChange={handleSearchChange}
              sx={{ width: "300px" }}
              InputProps={{
                startAdornment: (
                  <InputAdornment position="start">
                    <Search />
                  </InputAdornment>
                ),
              }}
            />
          </Box>
          {/* Orders Table */}
          {orderStatusError && (
            <Box sx={{ mb: 2, p: 2, bgcolor: "#ffebee", borderRadius: 1 }}>
              <Typography color="error">
                Error loading orders: {orderStatusError.message || "Please try again"}
              </Typography>
            </Box>
          )}
          <TableContainer component={Paper} sx={{ borderRadius: "20px" }}>
            <Table>
              <TableHead>
                <TableRow>
                  <TableCell sx={{ fontWeight: "bold" }}>ORDER ID</TableCell>
                  {/* <TableCell>TRACKING NUMBER</TableCell> */}
                  <TableCell sx={{ fontWeight: "bold" }}>CREATED</TableCell>
                  <TableCell sx={{ fontWeight: "bold" }}>CUSTOMER</TableCell>
                  <TableCell sx={{ fontWeight: "bold" }}>TOTAL</TableCell>
                  <TableCell sx={{ fontWeight: "bold" }}>PROFIT</TableCell>
                  <TableCell sx={{ fontWeight: "bold" }}>STATUS</TableCell>
                  <TableCell align="right" sx={{ fontWeight: "bold" }}>
                    ACTIONS
                  </TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {loading || orderStatusLoading ? (
                  <TableRow>
                    <TableCell colSpan={7} align="center" sx={{ py: 5 }}>
                      <CircularProgress />
                      <Typography sx={{ mt: 2 }}>Loading orders...</Typography>
                    </TableCell>
                  </TableRow>
                ) : filteredOrders.length === 0 ? (
                  <TableRow>
                    <TableCell colSpan={7} align="center" sx={{ py: 5 }}>
                      <Typography>No orders found</Typography>
                    </TableCell>
                  </TableRow>
                ) : (
                  filteredOrders.map((order, index) => (
                    <TableRow key={index}>
                      <TableCell>{order.id || order.cart_number || "N/A"}</TableCell>
                      {/* <TableCell>{order.trackingNumber}</TableCell> */}
                      <TableCell>{order.created || "N/A"}</TableCell>
                      <TableCell>{order.customer || "N/A"}</TableCell>
                      <TableCell>{order.total || "N/A"}</TableCell>
                      <TableCell>
                        {order.profit || "N/A"}
                        {order.profitPercent && (
                          <Box
                            component="span"
                            sx={{
                              backgroundColor: "rgba(76, 175, 80, 0.2)",
                              borderRadius: "10px",
                              padding: "2px 8px",
                              color: "#4CAF50",
                              fontWeight: "bold",
                              display: "inline-block",
                              ml: 1,
                            }}
                          >
                            {order.profitPercent}
                          </Box>
                        )}
                      </TableCell>
                      <TableCell>
                        <Typography
                          sx={{
                            backgroundColor: statusColors[order.status || order.order_status] || "rgba(158, 158, 158, 0.2)",
                            borderRadius: "10px",
                            padding: "4px 12px",
                            color: statusTextColors[order.status || order.order_status] || "#757575",
                            fontWeight: "bold",
                            display: "inline-block",
                          }}
                        >
                          {order.status || order.order_status || "N/A"}
                        </Typography>
                      </TableCell>
                      <TableCell align="right">
                        <Box
                          sx={{
                            display: "flex",
                            flexDirection: "column",
                            alignItems: "center",
                          }}
                          onClick={() => setOpen(true)}
                        >
                          {/* View Icon with navigation */}
                          <VisibilityIcon
                            onClick={() => handleEditClick(order)}
                            style={{ cursor: "pointer" }}
                          />
                        </Box>
                      </TableCell>
                    </TableRow>
                  ))
                )}
              </TableBody>
            </Table>
          </TableContainer>

          <Box
            sx={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              mt: 2,
            }}
          >
            <Typography variant="body2">
              Showing {filteredOrders.length} of {orderData.length}
            </Typography>
            <Box>
              <IconButton sx={{ color: "#4F46E5" }}>⟨</IconButton>
              {[1, 2, 3, 4, 5].map((page) => (
                <IconButton key={page} sx={{ color: "#4F46E5" }}>
                  {page}
                </IconButton>
              ))}
              <IconButton sx={{ color: "#4F46E5" }}>⟩</IconButton>
            </Box>
          </Box>
        </Box>

        {/* Order Details Modal */}
        <Dialog
          open={isOrderModalOpen}
          onClose={handleModalClose}
          maxWidth="md"
          fullWidth
        >
          <DialogTitle sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
            Order Details
            <IconButton
              onClick={handleModalClose}
              sx={{
                color: (theme) => theme.palette.grey[500],
              }}
            >
              ×
            </IconButton>
          </DialogTitle>
          <DialogContent sx={{ p: 3 }}>
            {selectedOrder && (
              <Box>
                {/* Agent Section */}
                <Box
                  sx={{
                    border: "1px solid #e0e0e0",
                    borderRadius: 2,
                    padding: 2,
                    mb: 3,
                    backgroundColor: "#f9f9f9",
                  }}
                >
                  <Typography variant="h6" sx={{ mb: 2, color: "#3f51b5" }}>
                    Agent Information
                  </Typography>
                  <Grid container spacing={2}>
                    <Grid item xs={6}>
                      <Typography variant="body2" color="textSecondary">
                        Agent Name
                      </Typography>
                      <Typography variant="body1" sx={{ fontWeight: "bold" }}>
                        {selectedOrder.agentName || "N/A"}
                      </Typography>
                    </Grid>
                    <Grid item xs={6}>
                      <Typography variant="body2" color="textSecondary">
                        Phone Number
                      </Typography>
                      <Typography variant="body1" sx={{ fontWeight: "bold" }}>
                        {selectedOrder.agentPhone || "N/A"}
                      </Typography>
                    </Grid>
                  </Grid>
                </Box>

                {/* Order Details Section */}
                <Box
                  sx={{
                    border: "1px solid #e0e0e0",
                    borderRadius: 2,
                    padding: 2,
                    mb: 3,
                    backgroundColor: "#fff",
                  }}
                >
                  <Typography variant="h6" sx={{ mb: 2, color: "#3f51b5" }}>
                    Order Details
                  </Typography>
                  <Grid container spacing={2}>
                    <Grid item xs={6}>
                      <Typography variant="body2" color="textSecondary">
                        Order ID
                      </Typography>
                      <Typography variant="body1" sx={{ fontWeight: "bold" }}>
                        {selectedOrder.id || selectedOrder.cart_number || "N/A"}
                      </Typography>
                    </Grid>
                    <Grid item xs={6}>
                      <Typography variant="body2" color="textSecondary">
                        Customer Name
                      </Typography>
                      <Typography variant="body1" sx={{ fontWeight: "bold" }}>
                        {selectedOrder.customer ||
                         (selectedOrder.cart?.customerDetails ?
                           `${selectedOrder.cart.customerDetails.first_name || ""} ${selectedOrder.cart.customerDetails.last_name || ""}`.trim()
                           : "N/A")}
                      </Typography>
                    </Grid>
                    <Grid item xs={6}>
                      <Typography variant="body2" color="textSecondary">
                        Total Amount
                      </Typography>
                      <Typography variant="body1" sx={{ fontWeight: "bold" }}>
                        {selectedOrder.total || selectedOrder.total_amount || "N/A"}
                      </Typography>
                    </Grid>
                    <Grid item xs={6}>
                      <Typography variant="body2" color="textSecondary">
                        Tracking Number
                      </Typography>
                      <Typography variant="body1" sx={{ fontWeight: "bold" }}>
                        {selectedOrder.trackingNumber || selectedOrder.cart?.transaction_id || "N/A"}
                      </Typography>
                    </Grid>
                  </Grid>
                </Box>

                {/* Status Section */}
                <Box
                  sx={{
                    border: "1px solid #e0e0e0",
                    borderRadius: 2,
                    padding: 2,
                    backgroundColor: "#fff",
                  }}
                >
                  <Typography variant="h6" sx={{ mb: 2, color: "#3f51b5" }}>
                    Status Information
                  </Typography>
                  <Grid container spacing={2}>
                    <Grid item xs={6}>
                      <Typography variant="body2" color="textSecondary">
                        Order Status
                      </Typography>
                      <Typography variant="body1" sx={{ fontWeight: "bold" }}>
                        {selectedOrder.status || selectedOrder.order_status || "N/A"}
                      </Typography>
                    </Grid>
                    <Grid item xs={6}>
                      <Typography variant="body2" color="textSecondary">
                        City
                      </Typography>
                      <Typography variant="body1" sx={{ fontWeight: "bold" }}>
                        {selectedOrder.city || "N/A"}
                      </Typography>
                    </Grid>
                    <Grid item xs={6}>
                      <Typography variant="body2" color="textSecondary">
                        Created
                      </Typography>
                      <Typography variant="body1" sx={{ fontWeight: "bold" }}>
                        {selectedOrder.created || selectedOrder.cart?.created_at || "N/A"}
                      </Typography>
                    </Grid>
                    <Grid item xs={6}>
                      <Typography variant="body2" color="textSecondary">
                        Variant Name
                      </Typography>
                      <Typography variant="body1" sx={{ fontWeight: "bold" }}>
                        {selectedOrder.varientName || "N/A"}
                      </Typography>
                    </Grid>
                  </Grid>
                </Box>
              </Box>
            )}
          </DialogContent>
          <DialogActions>
            <Button onClick={handleModalClose} variant="contained" color="primary">
              Close
            </Button>
          </DialogActions>
        </Dialog>
      </Box>
    </Box>
  );
}
